import React from 'react';
import { QueryClient, QueryClientProvider } from 'react-query';

import Content from './Content';

export interface PowerlistPersonData {
  rank: number;
  name: string;
  firm: string;
  value?: string;
  extra_credit?: string;
  key_exits?: string;
  key_active_investments?: string;
  description: string;
  notes?: string;
  source?: string;
  photo: string;
  type: string;
  article_title?: string;
  article_url?: string;
}

export interface PowerlistPersonDetails extends PowerlistPersonData {
  rowNum: string;
}

export interface PowerlistData {
  executives: PowerlistPersonData[];
  investors: PowerlistPersonData[];
  emerging: PowerlistPersonData[];
}

export interface PowerlistHeaderData {
  byline: string;
  description: string;
  articleSlug?: string;
}

export interface PowerlistPageProps {
  data: PowerlistData;
}

const queryClient = new QueryClient();

// if hitting the page as non subscriber, show locked homepage and only render header
const EnterprisePowerlist = (props: PowerlistPageProps) => {
  return (
    <QueryClientProvider client={queryClient}>
      <Content {...props} />
    </QueryClientProvider>
  );
};

export default EnterprisePowerlist;
